import { useQuery } from '@tanstack/react-query'
import { fetchAutomations, fetchSchedules, fetchTriggers } from '@/services/automations/automationsApi'
import { workspaceScopedKey } from '@/services/workspaces/workspaceQueryKeys'
import { getActiveWorkspaceId } from '@/store/workspaceStore'

const FETCHERS = { all: fetchAutomations, schedules: fetchSchedules, triggers: fetchTriggers }

export function useAutomations(surface = 'all', options = {}) {
  const workspaceId = getActiveWorkspaceId()
  return useQuery({
    queryKey: workspaceScopedKey(['do-chat', 'automations', surface]),
    queryFn: ({ signal }) => FETCHERS[surface]({ signal }),
    enabled: Boolean(workspaceId), retry: false, staleTime: 30_000,
    ...options,
  })
}
